import { Component, inject, Input, Signal } from '@angular/core';
import { AdPlacementRoadOccupationForm } from '../../forms/ad-placement-road-occupation.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  LocationDecisionsCrudComponent
} from '../../../../../common/components/location-decisions/location-decisions-crud/location-decisions-crud.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import { AdPlacementStageFormComponent } from '../ad-placement-stage-form/ad-placement-stage-form.component';
import { Store } from '@ngrx/store';
import { RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee } from '../../../../../../../../openapi';
import { selectPurposeFeeCollection } from '../../../../../../../../store/selectors/application.selectors';

@Component({
  selector: 'app-ad-placement-road-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LocationDecisionsCrudComponent,
    TabViewComponent,
    TabPanelComponent,
    AdPlacementStageFormComponent
  ],
  templateUrl: './ad-placement-road-occupation-form.component.html'
})
export class AdPlacementRoadOccupationFormComponent {

  @Input()
  public form: AdPlacementRoadOccupationForm | undefined;

  private store$ = inject(Store);

  public purposeFeeCollection: Signal<RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]> = this.store$.selectSignal(selectPurposeFeeCollection);
}
